import Dialog from "@chemaxon/terminus-client/ui/components/dialog/Dialog";
import { Group } from "@chemaxon/terminus-client/ui/models/Group";
import { CornerExtraLarge } from "@chemaxon/design-system/corners";
import GroupEditor from "@chemaxon/terminus-client/ui/components/groups/GroupEditor";
import GroupDetails from "@chemaxon/terminus-client/ui/components/groups/GroupDetails";

export default function EditGroup(props: Props) {
  if (props.group === null) {
    return;
  }

  return (
    <Dialog
      title="Manage group"
      open={props.isShown}
      content={
        props.scim ? (
          <GroupDetails group={props.group} onCancel={props.onCancel} />
        ) : (
          <GroupEditor group={props.group} onCancel={props.onCancel} />
        )
      }
      onClose={props.onCancel}
      divider={false}
      borderRadius={CornerExtraLarge.borderRadius}
      maxWidth="md"
    />
  );
}

type Props = {
  isShown: boolean;
  onCancel: () => void;
  group: Group | null;
  scim: boolean | undefined;
};
